var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderExcecution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66659V2.66659C9.99984 3.60925 9.99984 4.08059 10.2932 4.37325C10.5852 4.66659 11.0565 4.66659 11.9998 4.66659H12.9998M7.99984 7.33325V9.33325M7.99984 9.33325V11.3333M7.99984 9.33325H4.99984M7.99984 9.33325H10.9998M2.6665 10.6666V5.33325C2.6665 3.44792 2.6665 2.50459 3.2525 1.91925C3.83784 1.33325 4.78117 1.33325 6.6665 1.33325H9.44784C9.71984 1.33325 9.8565 1.33325 9.97917 1.38392C10.1012 1.43459 10.1978 1.53059 10.3905 1.72392L12.9425 4.27592C13.1358 4.46925 13.2318 4.56525 13.2825 4.68792C13.3332 4.80992 13.3332 4.94659 13.3332 5.21859V10.6666C13.3332 12.5519 13.3332 13.4953 12.7472 14.0806C12.1618 14.6666 11.2185 14.6666 9.33317 14.6666H6.6665C4.78117 14.6666 3.83784 14.6666 3.2525 14.0806C2.6665 13.4953 2.6665 12.5519 2.6665 10.6666ZM6.33317 11.3333H9.6665C10.2952 11.3333 10.6092 11.3333 10.8045 11.1379C10.9998 10.9426 10.9998 10.6286 10.9998 9.99992V8.66659C10.9998 8.03792 10.9998 7.72392 10.8045 7.52859C10.6092 7.33325 10.2952 7.33325 9.6665 7.33325H6.33317C5.7045 7.33325 5.3905 7.33325 5.19517 7.52859C4.99984 7.72392 4.99984 8.03792 4.99984 8.66659V9.99992C4.99984 10.6286 4.99984 10.9426 5.19517 11.1379C5.3905 11.3333 5.7045 11.3333 6.33317 11.3333Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderExcecution);
export default __webpack_public_path__ + "static/media/orderExcecution.70c03d224bcd1d2097c3f291fae40d54.svg";
export { ForwardRef as ReactComponent };